import StripePaymentScreen from 'components/payment/StripePaymentScreen'

const PaymentMethod = () => {
  return (
    <StripePaymentScreen />
  )
}

export default PaymentMethod
